import React from 'react';
import { useQuery, useMutation, gql } from '@apollo/client';

const GET_PRODUCTS = gql`
  query {
    products {
      id
      sku
      name
      price
      inventory
    }
  }
`;

const DELETE_PRODUCT = gql`
  mutation ($id: ID!) {
    deleteProduct(id: $id)
  }
`;

export default function ProductList({ onEdit }) {
  const { loading, error, data, refetch } = useQuery(GET_PRODUCTS);
  const [deleteProduct] = useMutation(DELETE_PRODUCT);

  const handleDelete = async (id) => {
    try {
      await deleteProduct({ variables: { id } });
      refetch();
    } catch (err) {
      console.error('Error deleting product:', err);
    }
  };

  const handleEdit = (product) => {
    if (onEdit) onEdit(product);
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div>
      <h2>Products</h2>
      <button onClick={() => refetch()}>Refresh</button>
      <ul>
        {data.products.map((p) => (
          <li key={p.id}>
            {p.name} - ${p.price} - Inventory: {p.inventory}
            <button onClick={() => handleEdit(p)} style={{ marginLeft: '10px' }}>
              Edit
            </button>
            <button onClick={() => handleDelete(p.id)} style={{ marginLeft: '10px' }}>
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
